import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();


const isOAuthProxyPath = window.location.pathname.startsWith('/~oauth');

if (isOAuthProxyPath) {
  navigator.serviceWorker?.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .finally(() => {
      const hasRetried = sessionStorage.getItem('oauth-callback-retried') === 'true';

      if (hasRetried) {
        window.location.replace('/auth?oauth_error=callback');
        return;
      }

      sessionStorage.setItem('oauth-callback-retried', 'true');
      window.location.reload();
    });
} else if (!isOAuthProxyPath) {
  sessionStorage.removeItem('oauth-callback-retried');
}

// Register service worker for push notifications
if (!isOAuthProxyPath && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

if (!isOAuthProxyPath) {
  createRoot(document.getElementById("root")!).render(<App />);
}
